import { Injectable } from '@angular/core';
import { TreetopPropertiesProvider } from 'shared/util-common';

/**
 * Abstracts logging functionality.
 * Note that in production mode we don't log to console.
 */
@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  log(context: string, message: string): void {
    if (TreetopPropertiesProvider.properties.production) {
      return;
    }

    // eslint-disable-next-line no-console
    console.log(`[${context}] ${message}`);
  }

  warn(context: string, message: string): void {
    if (TreetopPropertiesProvider.properties.production) {
      return;
    }
    console.warn(`[${context}] ${message}`);
  }

  error(context: string, message: string, e: Error): void {
    if (TreetopPropertiesProvider.properties.production) {
      return;
    }
    console.error(`[${context}] ${message}`, e);
  }
}
